import { ITheme } from "../../../constants/theme";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles((theme: ITheme) => ({

  card: {
    position: "relative",
  },
  gameImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    aspectRatio: "3 / 5",
    borderRadius: theme.radius.medium,
  },
  layer: {
    position: "absolute",
    height: "100%",
    width: "100%",
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0.45) 100%)",
    borderRadius: theme.radius.medium,
  },
  videoWrapper: {
    position: "absolute",
    inset: 0,
    transition: "opacity 300ms ease",
    borderRadius: theme.radius.medium,
  },
}));